import SDDInstructions from 'components/FrictionlessCheckout/DeliverToReleaseThree/SDDInstructions/SDDInstructions';
import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import OrderActions from 'actions/OrderActions';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import DeliveryOptionsUtils from 'utils/DeliveryOptions';
import { orderDetailsSelector } from 'selectors/order/orderDetails/orderDetailsSelector';
import OrderUtils from 'utils/Order';
import Empty from 'constants/empty';
import SDDInstructionsEN from 'components/FrictionlessCheckout/DeliverToReleaseThree/SDDInstructions/locales/SDDInstructions_en_US';
import SDDInstructionsFR from 'components/FrictionlessCheckout/DeliverToReleaseThree/SDDInstructions/locales/SDDInstructions_fr_CA';

const { wrapHOC } = FrameworkUtils;
const { saveDeliveryInstructions } = OrderActions;
const { getLocalisedDataFromResource, getTextFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(SDDInstructionsEN, SDDInstructionsFR);
const { isNDDNewDeliveryName } = DeliveryOptionsUtils;

const fields = createSelector(
    createStructuredSelector({
        sameDayTitle: getTextFromResource(getText, 'title'),
        fastDeliveryTitle: getTextFromResource(getText, 'fastDeliveryInstructionsTitle'),
        textInputLabel: getTextFromResource(getText, 'textInputLabel'),
        deliveryNote: getTextFromResource(getText, 'deliveryNote'),
        optional: getTextFromResource(getText, 'optional'),
        cancel: getTextFromResource(getText, 'cancel'),
        saveInstructions: getTextFromResource(getText, 'saveInstructions'),
        edit: getTextFromResource(getText, 'edit')
    }),
    orderDetailsSelector,
    (textResources, orderDetails) => {
        const { deliveryInstructions = '' } = OrderUtils.getSameDayShippingGroup(orderDetails) || Empty.Object;

        // Feature flag check: use Fast Delivery title when KS enabled
        const title = isNDDNewDeliveryName() ? textResources.fastDeliveryTitle : textResources.sameDayTitle;

        const locales = {
            ...textResources,
            title
        };

        return {
            locales,
            deliveryInstructions
        };
    }
);

const functions = {
    saveDeliveryInstructions
};

const withSDDInstructionsProps = wrapHOC(connect(fields, functions));

const ConnectedDeliveryInstructions = withSDDInstructionsProps(SDDInstructions);

export default ConnectedDeliveryInstructions;
